/**
 * Return whether a node is an unconditional reference to an existing resource.
 */
export default node => !!(node.reference && node.reference.arn);
